import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  retrieveDestinations,
  searchConnection,
  searchDirect,
} from "../../api";
import { addDays, format, formatRFC3339 } from "date-fns";
import {
  AppConfig,
  FlightTypeSelect,
  Mapper,
  SearchFlightsForm,
} from "../../types";
import { createAppAsyncThunk } from "../../app/hooks";
interface FetchResultsProps {
  form: any;
  appConfig: AppConfig;
}

export const fetchOutboundDirects = createAsyncThunk(
  "searchFlights/fetchOutboundDirects",
  async (props: FetchResultsProps) => {
    return await searchDirect(props.form, props.appConfig);
  }
);

export const fetchOutboundConnections = createAsyncThunk(
  "searchFlights/fetchOutboundConnections",
  async (props: FetchResultsProps) => {
    return await searchConnection(props.form, props.appConfig);
  }
);

export const fetchReturnDirects = createAsyncThunk(
  "searchFlights/fetchReturnDirects",
  async (props: FetchResultsProps) => {
    return await searchDirect(props.form, props.appConfig);
  }
);

export const fetchReturnConnections = createAsyncThunk(
  "searchFlights/fetchReturnConnections",
  async (props: FetchResultsProps) => {
    return await searchConnection(props.form, props.appConfig);
  }
);

interface fetchResultsProps {
  queryTrigger: string;
}

interface fetchDestinationsResultsProps extends fetchResultsProps {}

const pref = (mapper: Mapper) => {
  const request = {
    originCriteria: null,
    carrier1Criteria: null,
    carrier2Criteria: null,
    carrier3Criteria: null,
    prefferedCarrier: null,
    preferredCarrierCriteria: null,
    destinationCriteria: null,
  };
  if (
    mapper.flightFinder.connections.carrier1Criteria !== null &&
    mapper.flightFinder.connections.carrier1Criteria !== ""
  ) {
    request.carrier1Criteria = mapper.flightFinder.connections.carrier1Criteria;
  }

  if (
    mapper.flightFinder.connections.carrier2Criteria !== null &&
    mapper.flightFinder.connections.carrier2Criteria !== ""
  ) {
    request.carrier2Criteria = mapper.flightFinder.connections.carrier2Criteria;
  }

  if (
    mapper.flightFinder.connections.carrier3Criteria !== null &&
    mapper.flightFinder.connections.carrier3Criteria !== ""
  ) {
    request.carrier3Criteria = mapper.flightFinder.connections.carrier3Criteria;
  }

  if (
    mapper.flightFinder.connections.prefferedCarrier !== null &&
    mapper.flightFinder.connections.prefferedCarrier !== ""
  ) {
    request.prefferedCarrier = mapper.flightFinder.connections.prefferedCarrier;
  }

  if (
    mapper.flightFinder.connections.preferredCarrierCriteria !== null &&
    mapper.flightFinder.connections.preferredCarrierCriteria !== ""
  ) {
    request.preferredCarrierCriteria =
      mapper.flightFinder.connections.preferredCarrierCriteria;
  }

  if (
    mapper.flightFinder.connections.originCriteria !== null &&
    mapper.flightFinder.connections.originCriteria !== ""
  ) {
    request.originCriteria = mapper.flightFinder.connections.originCriteria;
    // outRequestConnections.originCriteriaLocationType = mapper.flightFinder.connections.originCriteriaLocationType;
  }

  if (
    mapper.flightFinder.connections.destinationCriteria !== null &&
    mapper.flightFinder.connections.destinationCriteria !== ""
  ) {
    request.destinationCriteria =
      mapper.flightFinder.connections.destinationCriteria;
    // outRequestConnections.destinationCriteriaLocationType = mapper.flightFinder.connections.destinationCriteriaLocationType;
  }
  return request;
};

export const fetchDestinationsResults = createAppAsyncThunk(
  "searchDestinations/fetchResults",
  async (props, thunkAPI) => {
    const state = thunkAPI.getState();
    const config = state.config;
    const form = state.searchFlights.form as SearchFlightsForm;

    const requestDate = format(form.departingDate, "yyyy-MM-dd");
    const request = {
      destinationCriteria: "***",
      destinationCriteriaLocationType: "A",
      originCriteria: form.originAirport.port.code,
      originCriteriaLocationType: "A",
      requestDate,
      requestDateEffectiveFrom: requestDate,
      requestDateEffectiveTo: requestDate,
      requestTime: "00:01:00",
      language: config.app.language,
    };
    return retrieveDestinations(request, config.app);
  }
);

export const fetchResults = createAppAsyncThunk(
  "searchFlights/fetchResults",
  async ({ queryTrigger }: fetchResultsProps, thunkAPI) => {
    const state = thunkAPI.getState();
    const config = state.config;
    const form = state.searchFlights.form as SearchFlightsForm;
    const promises = [];

    let requestDate;
    let requestDateEffectiveFrom = null;
    let requestDateEffectiveTo = null;

    let rtnRequestDate;
    let rtnRequestDateEffectiveFrom = null;
    let rtnRequestDateEffectiveTo = null;

    if (form.dateRange || form.dateRangeWeekly) {
      requestDate = format(form.departingDateFrom, "yyyy-MM-dd");
      requestDateEffectiveFrom = requestDate;
      requestDateEffectiveTo = format(form.departingDateTo, "yyyy-MM-dd");
      rtnRequestDate = format(addDays(form.returningDate, 1), "yyyy-MM-dd");
      rtnRequestDateEffectiveFrom = rtnRequestDate;
      rtnRequestDateEffectiveTo = format(form.returningDateTo, "yyyy-MM-dd");
    } else {
      requestDate = format(form.departingDate, "yyyy-MM-dd");
      rtnRequestDate = format(form.returningDate, "yyyy-MM-dd");
    }

    if (
      form.direction !== "via" &&
      form.flightType !== FlightTypeSelect.Connecting
    ) {
      promises.push(
        thunkAPI.dispatch(
          fetchOutboundDirects({
            appConfig: config.app,
            form: {
              ...config.cbwsRequest,
              ...pref(config.mapper),
              description: "outbound-directs",
              requestType: "outbound",
              requestTime: form.departingTime + ":00",
              originCriteria: form.originAirport.port.code,
              originCriteriaLocationType: form.originAirport.port.type || "A",
              destinationCriteria: form.destinationAirport.port.code,
              destinationCriteriaLocationType:
                form.destinationAirport.port.type || "A",
              requestDate: requestDate,
              requestDateEffectiveFrom: requestDateEffectiveFrom,
              requestDateEffectiveTo: requestDateEffectiveTo,
              rtnRequestDate: rtnRequestDate,
              rtnRequestTime: form.returningTime + ":00",
              nonStopDirect: form.nonStopFlights,
              numberOfStops: form.nonStopFlights ? 0 : null,
              stopsLtGtEq: form.nonStopFlights ? "=" : null,
              includeCodeShare: form.includeCodeShare,
            },
          })
        )
      );
      if (form.roundTrip) {
        promises.push(
          thunkAPI.dispatch(
            fetchReturnDirects({
              appConfig: config.app,
              form: {
                ...config.cbwsRequest,
                ...pref(config.mapper),
                description: "return-directs",
                requestType: "return",
                requestTime: form.returningTime + ":00",
                originCriteria: form.destinationAirport.port.code,
                originCriteriaLocationType:
                  form.destinationAirport.port.type || "A",
                destinationCriteria: form.originAirport.port.code,
                destinationCriteriaLocationType:
                  form.originAirport.port.type || "A",
                requestDate: rtnRequestDate,
                requestDateEffectiveFrom: rtnRequestDateEffectiveFrom,
                requestDateEffectiveTo: rtnRequestDateEffectiveTo,
                rtnRequestDate: null,
                rtnRequestTime: formatRFC3339(form.returningDate),
                nonStopDirect: form.nonStopFlights,
                numberOfStops: form.nonStopFlights ? 0 : null,
                stopsLtGtEq: form.nonStopFlights ? "=" : null,
                includeCodeShare: form.includeCodeShare,
              },
            })
          )
        );
      }
    }
    if (
      config.mapper.flightFinder.connections.enable &&
      (!form.nonStopFlights || form.direction === "via")
    ) {
      promises.push(
        thunkAPI.dispatch(
          fetchOutboundConnections({
            appConfig: config.app,
            form: {
              ...config.cbwsRequest,
              ...pref(config.mapper),
              description: "outbound-connections",
              requestType: "outbound",
              requestTime: form.departingTime + ":00",
              originCriteria: form.originAirport.port.code,
              originCriteriaLocationType: form.originAirport.port.type || "A",
              destinationCriteria: form.destinationAirport.port.code,
              destinationCriteriaLocationType:
                form.destinationAirport.port.type || "A",
              via1Criteria: form.viaAirport && form.viaAirport.port.code,
              requestDate: form.dateRangeWeekly
                ? requestDate
                : format(form.departingDate, "yyyy-MM-dd"),
              requestDateEffectiveFrom: form.dateRangeWeekly
                ? requestDateEffectiveFrom
                : null,
              requestDateEffectiveTo: form.dateRangeWeekly
                ? requestDateEffectiveTo
                : null,
              rtnRequestDate: null,
              rtnRequestTime: form.returningTime + ":00",
              operatingCarrierOnly: !form.includeCodeShare,
              includeCodeShare: form.includeCodeShare,
            },
          })
        )
      );
      if (form.roundTrip) {
        promises.push(
          thunkAPI.dispatch(
            fetchReturnConnections({
              appConfig: config.app,
              form: {
                ...config.cbwsRequest,
                ...pref(config.mapper),
                description: "return-connections",
                requestType: "return",
                requestTime: form.returningTime + ":00",
                originCriteria: form.destinationAirport.port.code,
                originCriteriaLocationType:
                  form.destinationAirport.port.type || "A",
                destinationCriteria: form.originAirport.port.code,
                destinationCriteriaLocationType:
                  form.originAirport.port.type || "A",
                via1Criteria: form.viaAirport && form.viaAirport.port.code,
                requestDate: form.dateRangeWeekly
                  ? rtnRequestDate
                  : format(form.returningDate, "yyyy-MM-dd"),
                requestDateEffectiveFrom: form.dateRangeWeekly
                  ? rtnRequestDateEffectiveFrom
                  : null,
                requestDateEffectiveTo: form.dateRangeWeekly
                  ? rtnRequestDateEffectiveTo
                  : null,
                rtnRequestDate: null,
                rtnRequestTime: formatRFC3339(form.returningDate),
                operatingCarrierOnly: !form.includeCodeShare,
                includeCodeShare: form.includeCodeShare,
              },
            })
          )
        );
      }
    }
    const values = await Promise.all(promises);

    // Get flight type toggle state to pass to reducer
    const updatedState = thunkAPI.getState();
    const { mapper } = updatedState.config;
    const visibleFlightType = updatedState.marker.visibleFlightType;

    return {
      queryTrigger,
      values,
      enableFlightTypeToggle: mapper.enableFlightTypeToggle,
      visibleFlightType,
    };
  }
);
